import { BADGE_TYPES, type BadgeType } from '@/constants/common.constants';
import {
  SURVEY_POSITIVE_SCORE_THRESHOLD,
  SURVEY_LIST_LOW_SCORE_THRESHOLD,
  SURVEY_ALERT_TYPE_LABELS,
} from '@/constants/survey.constants';
import { isEnpsDetractor } from '@/utils/route-survey';

/**
 * Get CSS classes for reviewed status badge
 */
export const getReviewedBadgeClasses = (viewed: boolean): string => {
  return viewed
    ? 'bg-success-light-1 text-success-dark-1 w-6 h-6 rounded-full inline-flex items-center justify-center text-xs'
    : 'bg-danger-light-1 text-danger-dark-1 w-6 h-6 rounded-full inline-flex items-center justify-center text-xs';
};

/**
 * Get badge type for alert type
 */
export const getAlertBadgeType = (alertTypeLabel: string): BadgeType => {
  if (alertTypeLabel === SURVEY_ALERT_TYPE_LABELS.low_score) {
    return BADGE_TYPES.DANGER;
  }
  if (alertTypeLabel === SURVEY_ALERT_TYPE_LABELS.comments) {
    return BADGE_TYPES.WARNING;
  }
  return BADGE_TYPES.NEUTRAL;
};

/**
 * Get CSS classes for score display (red if low)
 */
export const getScoreClasses = (score: number | null): string => {
  if (score === null) return '';
  const isLow = score < SURVEY_POSITIVE_SCORE_THRESHOLD;
  return isLow ? 'text-danger-dark-1 font-semibold' : '';
};

/**
 * Get CSS classes for the Surveys-page score column (red below the
 * surveys-list threshold of 70). Kept separate from getScoreClasses so the
 * lower threshold used on other pages is unaffected.
 */
export const getSurveyListScoreClasses = (score: number | null): string => {
  if (score === null) return '';
  const isLow = score < SURVEY_LIST_LOW_SCORE_THRESHOLD;
  return isLow ? 'text-danger-dark-1 font-semibold' : '';
};

/**
 * Get CSS classes for eNPS score display (red if detractor)
 */
export const getEnpsScoreClasses = (score: number | null): string => {
  if (score === null) return '';
  const isDetractor = isEnpsDetractor(score);
  return isDetractor ? 'text-danger-dark-1 font-semibold' : '';
};
